import React from 'react';
import FeeFieldsFormSection from './FeeFieldsFormSection';

/**
 * GOVOPS-1113 — shared quick intake fields (dashboard + admin).
 */
const PermitQuickIntakeForm = ({
  formData,
  onChange,
  onSubmit,
  submitting = false,
  error = '',
  success = '',
  idPrefix = 'intake',
  showOptionalFields = false,
  showFeeFields = false,
  submitLabel = 'Submit permit',
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...formData, [name]: value });
  };

  return (
    <form onSubmit={onSubmit} className="rhs-form-block rhs-form-block--compact">
      {error && (
        <p className="rhs-error" role="alert">
          {error}
        </p>
      )}
      {success && (
        <p className="rhs-ok-text" role="status">
          {success}
        </p>
      )}

      <label htmlFor={`${idPrefix}-type`}>Permit type</label>
      <input
        id={`${idPrefix}-type`}
        name="type"
        value={formData.type}
        onChange={handleChange}
        placeholder="e.g. Residential, Commercial"
        required
        disabled={submitting}
      />

      <label htmlFor={`${idPrefix}-description`}>Description</label>
      <textarea
        id={`${idPrefix}-description`}
        name="description"
        value={formData.description}
        onChange={handleChange}
        placeholder="Brief description of the alarm / site"
        rows={3}
        required
        disabled={submitting}
      />

      <div className="rhs-form-row">
        <div>
          <label htmlFor={`${idPrefix}-lat`}>Latitude</label>
          <input
            id={`${idPrefix}-lat`}
            name="latitude"
            type="number"
            step="any"
            value={formData.latitude}
            onChange={handleChange}
            placeholder="32.7157"
            required
            disabled={submitting}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}-lng`}>Longitude</label>
          <input
            id={`${idPrefix}-lng`}
            name="longitude"
            type="number"
            step="any"
            value={formData.longitude}
            onChange={handleChange}
            placeholder="-117.1611"
            required
            disabled={submitting}
          />
        </div>
      </div>

      {showOptionalFields && (
        <>
          <label htmlFor={`${idPrefix}-date`}>Incident date</label>
          <input
            id={`${idPrefix}-date`}
            name="date"
            type="date"
            value={formData.date}
            onChange={handleChange}
            disabled={submitting}
          />
          <label htmlFor={`${idPrefix}-permit-number`}>Permit number (optional)</label>
          <input
            id={`${idPrefix}-permit-number`}
            name="permitNumber"
            value={formData.permitNumber}
            onChange={handleChange}
            disabled={submitting}
          />
        </>
      )}

      {showFeeFields && (
        <FeeFieldsFormSection
          values={formData}
          onChange={onChange}
          disabled={submitting}
          idPrefix={`${idPrefix}-fee`}
        />
      )}

      <button type="submit" className="rhs-btn" disabled={submitting}>
        {submitting ? 'Submitting…' : submitLabel}
      </button>
    </form>
  );
};

export default PermitQuickIntakeForm;
